module.exports = __webpack_public_path__ + "img/dy.dbf15e22.png";